import ActionTypes from '@ziynx/action-types';

const initialState = {};

// HELPER FUNCTION FOR ARCHIVING
const archiveJob = (state, action) => {
  const jobList = (state?.results ?? []).map((job) => {
    if (job?._id === action?.id) {
      return {
        ...job,
        archived: !job?.archived,
      };
    }
    return job;
  });
  return jobList;
};

export default function reduceJob(state = initialState, action) {
  if (!action.type) {
    return state;
  }

  switch (action?.type) {
  case ActionTypes.job.getAllJobs.START:
    return {
      ...state,
      fetching: true,
      success: false,
      error: null,
      removing: null,
      removalSuccess: null,
      removalError: null,
    };

  case ActionTypes.job.getAllJobs.SUCCESS:
    return {
      ...state,
      ...(action?.response ?? {}),
      results: action?.response?.page > 0
        ? (state?.results ?? []).concat(action?.response?.results ?? [])
        : action?.response?.results,
      fetching: false,
      success: true,
      error: null,
    };

  case ActionTypes.job.getAllJobs.ERROR:
    return {
      ...state,
      fetching: false,
      success: false,
      error: action?.error,
    };

  case ActionTypes.job.removeJob.START:
    return {
      ...state,
      fetching: true,
      removing: true,
      removalSuccess: false,
      success: false,
      error: null,
    };

  case ActionTypes.job.removeJob.SUCCESS:
    return {
      ...state,
      removing: false,
      fetching: false,
      results: state?.results?.filter((job) => job?._id !== action?.id) ?? [],
      removalSuccess: true,
      success: true,
      removalError: null,
    };

  case ActionTypes.job.removeJob.ERROR:
    return {
      ...state,
      removing: false,
      removalSuccess: false,
      removalError: action?.error,
    };

  case ActionTypes.jobItem.archive.START:
    return {
      ...state,
      archiveFetch: true,
      archiveSuccess: false,
      archiveError: null,
      results: archiveJob(state, action),
    };

  case ActionTypes.jobItem.archive.SUCCESS:
    return {
      ...state,
      archiveFetch: false,
      archiveSuccess: true,
      archiveError: null,
    };

  case ActionTypes.jobItem.archive.ERROR:
    return {
      ...state,
      results: archiveJob(state, action),
      error: action?.error,
      archiveFetch: false,
      archiveSuccess: true,
      archiveError: true,
    };

  case ActionTypes.job.clearRemoval:
    return {
      ...state,
      results: [...state.results],
      removing: false,
      removalSuccess: false,
      removalError: null,
    };

  // When editing a job successfully and redirecting
  case ActionTypes.job.patchedJob:
    return {
      ...state,
      patchSuccess: true,
    };

  case ActionTypes.job.clearPatchedJob:
    return {
      ...state,
      patchSuccess: false,
    };

  case ActionTypes.job.clear:
    return initialState;

  case ActionTypes.jobItem.clear:
    return {
      ...state,
      archiveFetch: false,
      archiveSuccess: false,
      archiveError: null,
    };

  default:
    return state;
  }
}
